<template>
  <div class="full-layout">
    <router-view></router-view>
  </div>
</template>
